var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Grid, Stack, Typography } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import RemoveModeratorOutlinedIcon from '@mui/icons-material/RemoveModeratorOutlined';
import React, { useEffect, useState } from 'react';
import AutoCompleteDD from '../../components/FormComponents/AutoCompleteDD';
import TextField from '../../components/FormComponents/TextField';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { utility } from '../../utils';
import constants from '../../config/constants';
import { getCommaSeparatedForAmounts, convertStringValuesToNumbers } from '../../utils/commonUtilities';
import { TruncatedTooltipText } from '../../components/uiComponents/TruncatedTooltipText';
import TabSectionCard, { DataWrapper } from './components/TabSectionCard';
import { RESPONSIVE_FIELD_GRID_SX } from './utils/responsiveGrid';
var CONSENT_OPTIONS = [
    { Name: 'No', OId: 0 },
    { Name: 'Yes', OId: 1 },
];
var isEmptyValue = function (value) { return value === undefined || value === null || String(value).trim() === ''; };
var firstFilled = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values.find(function (value) { return !isEmptyValue(value); });
};
var findConsentOption = function (value) {
    return isEmptyValue(value) ? undefined : CONSENT_OPTIONS.find(function (option) { return option.OId === value || option.Name === value || String(option.OId) === String(value); });
};
var ConsentTag = function (_a) {
    var consent = _a.consent;
    var accepted = String(consent) === '1';
    var declined = String(consent) === '0';
    if (!accepted && !declined)
        return null;
    var tone = accepted
        ? { bg: 'linear-gradient(135deg, #E6F4E1 0%, #CFEAC8 100%)', color: '#3C7A2E' }
        : { bg: 'linear-gradient(135deg, #FBE9E8 0%, #F5D3D1 100%)', color: '#A5443E' };
    return (React.createElement(Box, { sx: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            px: 1.5,
            py: 0.5,
            borderRadius: '16px',
            background: tone.bg,
            color: tone.color,
            fontSize: 13,
            fontWeight: 600,
            whiteSpace: 'nowrap',
            '& svg': { fontSize: 18 },
        } },
        accepted ? React.createElement(CheckBoxOutlineBlankIcon, null) : React.createElement(RemoveModeratorOutlinedIcon, null),
        accepted ? 'Coverage accepted' : 'Coverage declined'));
};
var InsuranceManagement = function (_a) {
    var TxAspireOId = _a.TxAspireOId, _roleType = _a.roleType, hasEditAccess = _a.hasEditAccess, mainResp = _a.mainResp, onDataRefresh = _a.onDataRefresh;
    var _b = useState([]), insuranceData = _b[0], setInsuranceData = _b[1];
    var _c = useState(null), editingIndex = _c[0], setEditingIndex = _c[1];
    var _d = useState(null), formValues = _d[0], setFormValues = _d[1];
    var _e = useState(''), amountError = _e[0], setAmountError = _e[1];
    var getInsuranceManagementInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, resp, records, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    payload = {
                        TxAspireOId: TxAspireOId
                    };
                    return [4, api_service.get({
                            endPoint: api_urls.GET_INSURANCE_DETAILS,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 1:
                    response = _c.sent();
                    if (response.data && response.data.statusCode === 200) {
                        resp = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
                        records = Array.isArray(resp) ? resp : [];
                        setInsuranceData(records.filter(function (record) { var _a; return /great american/i.test(String((_a = record === null || record === void 0 ? void 0 : record.InsuranceIntegration) !== null && _a !== void 0 ? _a : '')); }));
                    }
                    else {
                        utility.alert((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message, constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 3];
                case 2:
                    error_1 = _c.sent();
                    utility.alert(error_1, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    useEffect(function () {
        if (TxAspireOId) {
            getInsuranceManagementInfo();
        }
    }, [TxAspireOId]);
    var udfs = mainResp === null || mainResp === void 0 ? void 0 : mainResp.UDFsData;
    var getValues = function (insurance) {
        var _a, _b, _c, _d;
        return ({
            InsuranceConsent: (_a = firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceConsent, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceConsent)) !== null && _a !== void 0 ? _a : '',
            InsuranceQuoteID: String((_b = firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceQuoteID, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceQuoteID)) !== null && _b !== void 0 ? _b : ''),
            InsuranceEnrollment: String((_c = firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceEnrollment, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceEnrollment)) !== null && _c !== void 0 ? _c : ''),
            InsuranceQuotationAmount: String((_d = firstFilled(insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceQuotationAmount, udfs === null || udfs === void 0 ? void 0 : udfs.InsuranceQuotationAmount)) !== null && _d !== void 0 ? _d : ''),
        });
    };
    var startEdit = function (index, insurance) {
        setFormValues(getValues(insurance));
        setAmountError('');
        setEditingIndex(index);
    };
    var cancelEdit = function () {
        setEditingIndex(null);
        setFormValues(null);
        setAmountError('');
    };
    var handleFieldChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        var updated = value;
        if (name === 'InsuranceQuotationAmount') {
            var stripped = String(value).replace(/[$,]/g, '');
            updated = /^\d*\.?(\d*)?$/.test(stripped) ? stripped : stripped.slice(0, -1);
            setAmountError('');
        }
        setFormValues(function (prev) {
            var _a;
            return (prev ? __assign(__assign({}, prev), (_a = {}, _a[name] = updated, _a)) : prev);
        });
    };
    var handleSave = function (insurance) { return __awaiter(void 0, void 0, void 0, function () {
        var original, changes, amount, response, error_2;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    if (!formValues)
                        return [2];
                    original = getValues(insurance);
                    changes = {};
                    if (String(formValues.InsuranceConsent) !== String(original.InsuranceConsent)) {
                        changes.InsuranceConsent = formValues.InsuranceConsent === '' ? null : formValues.InsuranceConsent;
                    }
                    if (isEmptyValue(original.InsuranceQuoteID) && !isEmptyValue(formValues.InsuranceQuoteID)) {
                        changes.InsuranceQuoteID = formValues.InsuranceQuoteID.trim();
                    }
                    if (isEmptyValue(original.InsuranceQuotationAmount) && !isEmptyValue(formValues.InsuranceQuotationAmount)) {
                        amount = Number(convertStringValuesToNumbers(formValues.InsuranceQuotationAmount));
                        if (isNaN(amount) || amount < 0 || amount >= 100000000) {
                            setAmountError('Amount should be less than 100,000,000');
                            return [2];
                        }
                        changes.InsuranceQuotationAmount = amount;
                    }
                    if (Object.keys(changes).length === 0) {
                        cancelEdit();
                        return [2];
                    }
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 8, , 9]);
                    return [4, api_service.put({
                            endPoint: api_urls.UPDATE_BACKLOG_UDFS,
                            payLoad: __assign(__assign({ ContractAspireId: (_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _a === void 0 ? void 0 : _a.ContractAspireId, ApplicationType: (_b = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _b === void 0 ? void 0 : _b.ContractCategory, TxAspireOId: (_d = (_c = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _c === void 0 ? void 0 : _c.TxAspireOId) !== null && _d !== void 0 ? _d : TxAspireOId }, (((_e = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _e === void 0 ? void 0 : _e.ContractCategory) === 'SCH' && { LOCAspireOId: (_f = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _f === void 0 ? void 0 : _f.LOCAspireOId })), changes),
                            showLoader: true,
                        })];
                case 2:
                    response = _k.sent();
                    if (!(((_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.statusCode) === 200)) return [3, 6];
                    utility.alert((_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.message, constants.TOAST_TYPES.INFO);
                    cancelEdit();
                    if (!onDataRefresh) return [3, 4];
                    return [4, onDataRefresh()];
                case 3:
                    _k.sent();
                    _k.label = 4;
                case 4: return [4, getInsuranceManagementInfo()];
                case 5:
                    _k.sent();
                    return [3, 7];
                case 6:
                    utility.alert((_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.message, constants.TOAST_TYPES.ERROR);
                    _k.label = 7;
                case 7: return [3, 9];
                case 8:
                    error_2 = _k.sent();
                    utility.alert(error_2, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_2);
                    return [3, 9];
                case 9: return [2];
            }
        });
    }); };
    var getSectionTitle = function (insurance, index) {
        var _a;
        var name = String((_a = insurance === null || insurance === void 0 ? void 0 : insurance.InsuranceIntegration) !== null && _a !== void 0 ? _a : '').trim();
        if (!name)
            return insuranceData.length > 1 ? "Insurance-".concat(index + 1) : 'Insurance';
        return /insurance/i.test(name) ? name : "".concat(name, " Insurance");
    };
    var renderReadOnly = function (label, value) { return (React.createElement(DataWrapper, { gap: 1 },
        React.createElement(Typography, { variant: "caption", className: "title" },
            label,
            ":"),
        React.createElement(TruncatedTooltipText, { value: value }))); };
    return (React.createElement(Stack, { gap: 2 }, insuranceData === null || insuranceData === void 0 ? void 0 : insuranceData.map(function (insurance, index) {
        var _a;
        var isEditing = editingIndex === index && formValues !== null;
        var values = isEditing ? formValues : getValues(insurance);
        var original = getValues(insurance);
        var consentOption = findConsentOption(values.InsuranceConsent);
        var amountDisplay = isEmptyValue(values.InsuranceQuotationAmount) ? '--' : getCommaSeparatedForAmounts(values.InsuranceQuotationAmount);
        return (React.createElement(TabSectionCard, { key: index, title: getSectionTitle(insurance, index), showEditIcon: hasEditAccess && !isEditing, onEditClick: function () { return startEdit(index, insurance); }, showSaveCancel: isEditing, onSave: function () { return handleSave(insurance); }, onCancel: cancelEdit, headerActions: React.createElement(ConsentTag, { consent: consentOption === null || consentOption === void 0 ? void 0 : consentOption.OId }) },
            React.createElement(Grid, { container: true, spacing: 2, alignItems: "end", sx: RESPONSIVE_FIELD_GRID_SX },
                React.createElement(Grid, { item: true, xs: 4 }, isEditing ? (React.createElement(AutoCompleteDD, { options: CONSENT_OPTIONS, displayKey: "Name", valueKey: "OId", label: "Insurance Consent", placeholder: "Insurance Consent", handleChange: handleFieldChange, handleBlur: function () { }, selectedValue: consentOption !== null && consentOption !== void 0 ? consentOption : '', name: "InsuranceConsent", isMandatoryField: false, fontWeight: "600" })) : renderReadOnly('Insurance Consent', (_a = consentOption === null || consentOption === void 0 ? void 0 : consentOption.Name) !== null && _a !== void 0 ? _a : '--')),
                React.createElement(Grid, { item: true, xs: 4 }, isEditing && isEmptyValue(original.InsuranceQuoteID) ? (React.createElement(TextField, { label: "Insurance Quote ID", name: "InsuranceQuoteID", placeholder: "Insurance Quote ID", fullWidth: true, value: values.InsuranceQuoteID, onChange: handleFieldChange, type: "text", fontWeight: "600" })) : renderReadOnly('Insurance Quote ID', values.InsuranceQuoteID || '--')),
                React.createElement(Grid, { item: true, xs: 4 }, renderReadOnly('Insurance Enrollment ID', values.InsuranceEnrollment || '--')),
                React.createElement(Grid, { item: true, xs: 4 }, isEditing && isEmptyValue(original.InsuranceQuotationAmount) ? (React.createElement(TextField, { label: "Insurance Quotation Amount", name: "InsuranceQuotationAmount", placeholder: "Quote Amount", fullWidth: true, value: values.InsuranceQuotationAmount, onChange: handleFieldChange, error_message: amountError, error: Boolean(amountError), type: "text", IsAmount: true, IsZeroAllowble: true, regEx: /\D/g, fontWeight: "600" })) : renderReadOnly('Insurance Quotation Amount', amountDisplay)))));
    })));
};
export default InsuranceManagement;
